import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Import page components
import HomePage from './pages/HomePage';
import MartyrsPage from './pages/MartyrsPage';
import MartyrDetailPage from './pages/MartyrDetailPage';
import MapPage from './pages/MapPage';
import AddMartyrPage from './pages/AddMartyrPage';
import WritingsPage from './pages/WritingsPage';
import WritingDetailPage from './pages/WritingDetailPage';
import PoemsPage from './pages/PoemsPage';
import PoemDetailPage from './pages/PoemDetailPage';
import BiographyPage from './pages/BiographyPage';
import TimelinePage from './pages/TimelinePage';
import GalleryPage from './pages/GalleryPage';
import GuestbookPage from './pages/GuestbookPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

// Import admin page components
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminAddMartyrPage from './pages/admin/AdminAddMartyrPage';
import AdminEditMartyrPage from './pages/admin/AdminEditMartyrPage';
import AdminWritingsPage from './pages/admin/AdminWritingsPage';
import AdminPoemsPage from './pages/admin/AdminPoemsPage';
import AdminMediaPage from './pages/admin/AdminMediaPage';
import AdminTributesPage from './pages/admin/AdminTributesPage';
import Videos from './pages/admin/Videos';

// Import components
import ProtectedRoute from './components/ProtectedRoute';

function RedirectToGalleryVideos() {
  const { search } = useLocation();
  return <Navigate to={`/gallery/videos${search}`} replace />;
}

function RedirectMartyrDetail() {
  const { id } = useParams();
  return <Navigate to={`/martyr/${id}`} replace />;
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App min-h-screen bg-stone-50 dark:bg-stone-950">
        <Toaster position="top-center" />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/martyrs" element={<MartyrsPage />} />
          <Route path="/martyrs/:id" element={<RedirectMartyrDetail />} />
          <Route path="/martyr/:id" element={<MartyrDetailPage />} />
          <Route path="/writings" element={<WritingsPage />} />
          <Route path="/writings/:id" element={<WritingDetailPage />} />
          <Route path="/poems" element={<PoemsPage />} />
          <Route path="/poems/:id" element={<PoemDetailPage />} />
          <Route path="/biography" element={<BiographyPage />} />
          <Route path="/timeline" element={<TimelinePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/gallery/photos" element={<GalleryPage />} />
          <Route path="/gallery/videos" element={<GalleryPage />} />
          <Route path="/videos" element={<RedirectToGalleryVideos />} />
          <Route path="/guestbook" element={<GuestbookPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/add-martyr" element={<AddMartyrPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/add-martyr" 
            element={
              <ProtectedRoute>
                <AdminAddMartyrPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/edit-martyr/:id" 
            element={
              <ProtectedRoute>
                <AdminEditMartyrPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/writings" 
            element={
              <ProtectedRoute>
                <AdminWritingsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/poems" 
            element={
              <ProtectedRoute>
                <AdminPoemsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/media" 
            element={
              <ProtectedRoute>
                <AdminMediaPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/tributes" 
            element={
              <ProtectedRoute>
                <AdminTributesPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/videos" 
            element={
              <ProtectedRoute>
                <Videos />
              </ProtectedRoute>
            } 
          />
          
          {/* 404 Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
